const SPACES = /\s+/g;
const NON_WORD_CHARACTERS = /[^\w-]+/g;
const MULTIPLE_DASHES = /--+/g;
const LEADING_DASH = /^-+/;
const TRAILING_DASH = /-+$/;
const TRAILING_SLASH = /\/+$/;

export default {
  SPACES,
  NON_WORD_CHARACTERS,
  MULTIPLE_DASHES,
  LEADING_DASH,
  TRAILING_DASH,
  TRAILING_SLASH,
};
